import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import { ignoreUnhandledUserRejections } from "./utility/userRejection";

ignoreUnhandledUserRejections();

const root = ReactDOM.createRoot(document.getElementById("root"));
root?.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

reportWebVitals();
